import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';
import { Pagination } from '@core/entities';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CrmSurveyService {
  private readonly _http = inject(HttpClient);

  private readonly _apiUrl = environment.apiUrl;

  getActiveSurveys(pagination: Pagination) {
    return this._http.get(`${this._apiUrl}/get-crm-activesurvey/${pagination.page}/${pagination.pageSize}`).pipe(map((response: any) => response.result));
  }

  getMyVotedSurveys(userId: number, pagination: Pagination) {
    return this._http.get(`${this._apiUrl}/get-crm-myvotedsurvey/${userId}/${pagination.page}/${pagination.pageSize}`).pipe(map((response: any) => response.result));
  }

  getCompletedSurveys(pagination: Pagination) {
    return this._http.get(`${this._apiUrl}/get-crm-completesurvey/${pagination.page}/${pagination.pageSize}`).pipe(map((response: any) => response.result));
  }

  getSurveyById(surveyId: number) {
    return this._http.get(`${this._apiUrl}/get-crm-surveybyid/${surveyId}`).pipe(map((response: any) => response.result));
  }
}
